import { LightModeRounded, ModeNightRounded, KeyboardArrowUpRounded, KeyboardArrowDownRounded, KeyboardArrowRightRounded, KeyboardBackspaceRounded, FiberSmartRecordRounded, RemoveRounded, CloudUploadRounded, DoneAllRounded, DownloadRounded, MenuRounded, CloseRounded, Twitter, Instagram, PhotoRounded, FacebookRounded, WhatsApp, Telegram, Mail, LocationOn, LinkRounded, CallRounded, EmailRounded, SearchRounded, ShutterSpeedRounded, NoteAltRounded, NetworkPingRounded, PeopleRounded, Visibility, VisibilityOff, PasswordRounded, BlockRounded, CheckCircleOutlineRounded, ProductionQuantityLimitsRounded, Business, LocalConvenienceStoreRounded, DesignServicesRounded, StarOutlineRounded, StarRateRounded, AddShoppingCartRounded, ShoppingBasketRounded, DeleteOutlineRounded, AddRounded, PaymentsRounded, LocalShippingRounded, ShoppingCartCheckoutRounded, FavoriteBorderRounded, FavoriteRounded, MarkEmailReadRounded, LockRounded, AddBoxRounded, PageviewRounded, EditRounded, VisibilityRounded, NotificationsNoneRounded, DeleteRounded, PersonRounded, AccountBoxRounded, HourglassEmptyRounded, SupportAgentRounded, ShareRounded, SchoolRounded, AccountBalanceRounded, RocketLaunchRounded, PublicRounded, FlightRounded, DeliveryDiningRounded }  from '@mui/icons-material'

import { google, marketing, social, emailPromotion, emailMarketing, img1, img2, nurse, physicalTherapy, speech, occupationalTherapy, img3, img4, img5, img6, img7 } from '../assets';

export { LightModeRounded, ModeNightRounded, KeyboardArrowUpRounded, KeyboardArrowDownRounded, KeyboardArrowRightRounded, KeyboardBackspaceRounded, FiberSmartRecordRounded, RemoveRounded, CloudUploadRounded, DoneAllRounded, DownloadRounded, MenuRounded, CloseRounded, Twitter, Instagram, PhotoRounded, FacebookRounded, WhatsApp, Telegram, Mail, LocationOn, LinkRounded, CallRounded, EmailRounded, SearchRounded, ShutterSpeedRounded, NoteAltRounded, NetworkPingRounded, PeopleRounded, Visibility, VisibilityOff, PasswordRounded, BlockRounded, CheckCircleOutlineRounded, ProductionQuantityLimitsRounded, Business, LocalConvenienceStoreRounded, DesignServicesRounded, StarOutlineRounded, StarRateRounded, AddShoppingCartRounded, ShoppingBasketRounded, DeleteOutlineRounded, AddRounded, PaymentsRounded, LocalShippingRounded, ShoppingCartCheckoutRounded, FavoriteBorderRounded, FavoriteRounded, MarkEmailReadRounded, LockRounded, AddBoxRounded, PageviewRounded, EditRounded, VisibilityRounded, NotificationsNoneRounded, DeleteRounded, PersonRounded, AccountBoxRounded, HourglassEmptyRounded, SupportAgentRounded, ShareRounded, SchoolRounded, AccountBalanceRounded, RocketLaunchRounded, PublicRounded }


export const navLinks = [
  { name: 'home', link: '/'},
  { name: 'posts', link: '/posts'},
  { name: 'items', link: '/items'},
  { name: 'services', link: '/services'},
  // { name: 'extras'},
]

export const newsEventsList = [
  {
    title: "Upcoming activities and outings",
  },
  {
    title: "Holiday celebrations and special events",
  },
  {
    title: "Community news and updates",
  },
]

export const genderOptions = [
  {name: "male"},
  {name: "female"},
]

// title: "The Grandview"
// title: "Crown Residences"
// title: "The Opal"
// title: "Aurum Suites"
// title: "The Ivory"
// title: "Luxe Heights"
// title: "The Meridian"
// title: "Velour Living"
// title: "The Echelon"
// title: "Sovereign Place"
// title: "The Crest"
// title: "Élan Residences"

export const personalizedCare = [
  {
    question: "Skilled Nursing Services",
    answer: "Professional Nurses provide clinical care, medication management and recovery support at home.",
  },
  {
    question: "Physical and occupational Therapy",
    answer: "Restores mobility, strength and independence after illness or injury. Helps clients regain daily living skills and adapt safely at home",
  },
  {
    question: "Chronic Care",
    answer: "Supports long-term management of diabetes, heart disease and more...",
  },
];

export const testimonialsData = [
  {
    title: "Shalom Springs feels like home. The staff are like family!",
    name: "Rachel, resident",
    icon: img1
  },
  {
    title: "Best decision we made for Mom's care. Peace of mind for us.",
    name: "John, family member",
    icon: img2
  },
  {
    title: "Love the activities and friends I've made here!",
    name: "David, resident",
    icon: img2
  },
  {
    title: "Compassionate care and beautiful surroundings.",
    name: " Emily, family",
    icon: img1
  },
]

export const servicesData = [ 
  {
    icon: img3,
    title: "Home Aide Health",
    description: "Provide essential care and support in your home with our dedicated healthcare professionals."
  },
  {
    icon: img4,
    title: "Residential Care Service",
    description: "Quality support from our dedicated professionals."
  },
  {
    icon: img5,
    title: "Behavioral and Psychiatric",
    description: "Evidence-based mental health care solutions are provided."
  },
  {
    icon: img6,
    title: "Primary Care",
    description: "Preventative care focuses on your continued wellness."
  },
  {
    icon: img7,
    title: "Professional Pediatric Assistance",
    description: "Compassionate, expert care for infants and children on safety, comfort, and healthy development."
  },
]

export const faqs = [
    {
      id: 0,  
      header: "how do i navigate market place profile ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    },
    {
      id: 1,
      header: "how do i contact customer support ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum"
    },
    {
      id: 2,
      header: "Is my email address visible to others ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    },
    {
      id: 3,
      header: "Is my email address visible to others ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    },
    {
      id: 4,
      header: "Is my email address visible to others ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    }
]

export const featuresList = [
    {id: 1, icon: PublicRounded, title: 'Global Sourcing.', detail: 'Hexagon China helps businesses source quality products directly from China.'},
    {id: 2, icon: FlightRounded, title: 'We make China sourcing sample.', detail: '3-layer quality inspections before shipping'},
    {id: 3, icon: LocalShippingRounded, title: 'Africa-friendly services', detail: 'Seamless door-to-door shipping and customs handling'},
]

